<div class="card">
  <div class="card-header card-header-squirrel">
    <h4>{{this.translate.data['TENANTGROUPROLEPERMISSIONS'] | translate}}</h4>
    <h4>{{groupRoleName}}</h4>
  </div>
  
  <!-- <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <section class="example-full-width" *ngFor="let platformPermission of platformPermissions">
          <mat-slide-toggle color="primary" [(ngModel)]="platformPermission.permissionValue" (change)="onChange(platformPermissions, $event)"
            labelPosition="before">{{platformPermission.displayName}}</mat-slide-toggle> 
        </section>
      </div>
    </div>
  </div> -->
  <div class="card-body">
    <tenant-permissions-list [permissions]="actTenantGroupRole.permissions" [tenantRoles]="tenantRoles" (onChangeEvent)="onChange1($event)"></tenant-permissions-list>
    <!-- <div class="row button-right">
      <a>
        <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 35px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                        (click)="cancel()" >Abbruch</button>
      </a>                   
      <span style="flex: 1 1 auto"></span>
    </div> -->
    <div class="row">
      <a>
          <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                          (click)="cancel()" >Abbruch</button>
      </a>                                                
      <span style="flex: 1 1 auto"></span>
      <a>
          <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" 
          (click)="updateTGR()"  >Speichern
        </button>
          <!-- <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['ADDNEWPROJECT'] | translate}}"
              (click)="add()" >Hinzufügen
          (click)="updateTGR()"  [disabled]="!isFormValid()">Speichern
          </button> -->
      </a>                   
  </div>    

  </div>

</div>